import { render, staticRenderFns } from "./VerticalTabbedSection.vue?vue&type=template&id=54b96dc0"
import script from "./VerticalTabbedSection.vue?vue&type=script&lang=js"
export * from "./VerticalTabbedSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports